import { render } from "./togetherShop.vue?vue&type=template&id=a022c606&scoped=true"
import script from "./togetherShop.vue?vue&type=script&lang=js"
export * from "./togetherShop.vue?vue&type=script&lang=js"

import "./togetherShop.vue?vue&type=style&index=0&id=a022c606&scoped=true&lang=css"

import exportComponent from "C:\\src\\web\\finance\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a022c606"]])

export default __exports__